module.exports = __webpack_public_path__ + "images/emoji/foggy.931fa6d245c4df9f7419.png";